export default "__VITE_ASSET__DKjYOwds__"